module.exports = __webpack_public_path__ + "static/media/Vero.9c0fa2e5.jpg";